import { API } from "./API";
const base = 'https://ping.fastsimon.com';
export default function reportThankYou({ sessionToken, cartToken }) {
    var _a, _b;
    API.post({
        url: `${base}/sh_webhook_thank_you`,
        data: {
            host: Shopify.shop,
            order_id: (_a = Shopify.checkout.order_id) !== null && _a !== void 0 ? _a : "",
            st: sessionToken.start,
            cart_token: cartToken,
            location: window.location.href,
            subtotal_price: (_b = Shopify.checkout.subtotal_price) !== null && _b !== void 0 ? _b : ""
        }
    }).then(() => {
        console.log('fast simon: thank you reported!');
    }).catch(e => {
        console.error(e);
    });
}
export function isThankYou() {
    return typeof Shopify !== 'undefined' && typeof Shopify.checkout !== 'undefined' && window.location.href.includes('thank_you');
}
//# sourceMappingURL=thankYou.js.map